"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewRequirement = void 0;
const scholarship_requirement_type_1 = require("../types/scholarship-requirement-type");
const student_interfaces_1 = require("@studyportals/student-interfaces");
const data_storage_1 = require("@studyportals/data-storage");
const REVIEW_STORAGE_KEY = 'review_status';
class ReviewRequirement {
    constructor(sessionService, pathToEnableReviewRequirementCheck) {
        this.sessionService = sessionService;
        this.pathToEnableReviewRequirementCheck = pathToEnableReviewRequirementCheck;
        this.eventAggregationService = window.EventAggregationService;
        this.dataStorage = data_storage_1.DataStorage;
        this.type = scholarship_requirement_type_1.ScholarshipRequirementType.REVIEW;
        this.eventAggregationService.subscribeTo(student_interfaces_1.SessionDestroyedEvent.EventType, {
            notify: () => {
                data_storage_1.DataStorage.remove(REVIEW_STORAGE_KEY);
            },
        }, true);
    }
    isFulfilled() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isAPathEnabledToCheckReview())
                return false;
            if (this.storedValue())
                return true;
            const session = (yield ((_a = this.sessionService) === null || _a === void 0 ? void 0 : _a.getSession()));
            const accessToken = yield (session === null || session === void 0 ? void 0 : session.getAccessToken());
            if (!accessToken)
                return false;
            const hasReview = yield this.checkIfUserHasReviewed(accessToken);
            this.dataStorage.store(REVIEW_STORAGE_KEY, `${hasReview}`);
            return hasReview;
        });
    }
    getRequiredStudentFields() {
        return [];
    }
    checkIfUserHasReviewed(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${REVIEWS_API_URL}student/check`;
            const response = yield fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `${accessToken}`,
                },
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const data = yield response.json();
            return Boolean(data.result);
        });
    }
    storedValue() {
        const storedReviewStatus = this.dataStorage.retrieve(REVIEW_STORAGE_KEY);
        return storedReviewStatus === 'true';
    }
    isAPathEnabledToCheckReview() {
        return window.location.href.includes(this.pathToEnableReviewRequirementCheck);
    }
}
exports.ReviewRequirement = ReviewRequirement;
